import { HOURS_COUNT } from '@contexts/scheduler/constants';

export const getGridTemplateColumns = (hoursCount: number = HOURS_COUNT) => ({
  gridTemplateColumns: `repeat(${hoursCount + 1}, 1fr)`,
});
